"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__imgCache = void 0;
exports.readImage = readImage;
/* eslint-disable @typescript-eslint/no-throw-literal -- TODO Add comment */
/* istanbul ignore file */
/**
 * Internal Cache for images
 * @internal
 */
// eslint-disable-next-line @typescript-eslint/naming-convention -- TODO Add comment
const __imgCache = exports.__imgCache = new Map();

/**
 * readImage function that allows to use react suspense
 * @internal
 * @param {string} src src attribute
 * @param {string} [srcSet] srtSet Attribute
 * @throws { Promise<void> } Throws promise when image is still loading
 * @returns { true | ErrorEvent } Returns true when image was loaded and error when image filed to load
 */
function readImage(src, srcSet) {
  if (!__imgCache.has(src)) {
    __imgCache.set(src, new Promise((resolve, reject) => {
      const img = new Image();
      img.addEventListener('load', event => {
        __imgCache.set(src, true);
        resolve(event);
      });
      img.addEventListener('error', error => {
        reject(error);
      });
      img.src = src;
      if (srcSet) {
        img.srcset = srcSet;
      }
    }).then(() => {
      __imgCache.set(src, true);
    }).catch(error => {
      __imgCache.set(src, error);
    }));
  }
  if (__imgCache.get(src) instanceof Promise) {
    throw __imgCache.get(src);
  }
  return __imgCache.get(src);
}
//# sourceMappingURL=readImage.js.map